import { type ApprovalWorkflowNodeExport } from './approvalWorkflowExportTypes';

/**
 * Ensure there is always a null value node at the end
 *
 * Possible adjustment: maybe the null value should not be enforced when
 * non existing.
 */
export const ensureOtherValuesNodeLast = (
  nodes: ApprovalWorkflowNodeExport[],
): ApprovalWorkflowNodeExport[] => {
  const specifiedValuesNodes = nodes.filter((node) => node.values !== null);
  const otherValuesNode = nodes.find((node) => node.values === null);
  return [
    ...specifiedValuesNodes,
    {
      values: null,
      branch: otherValuesNode?.branch,
      approvalScheme: otherValuesNode?.approvalScheme,
    },
  ];
};
